import { useState } from 'react';
import SEO from '@/components/SEO';
import InfoTip from './InfoTip';
import { PLANS, COMPARISON, ADDONS, TRUST, FAQ,
  BENCHMARKS, YEAR_TWO, REFRAMES, VERIFIED_ON, PAINS, HEADLINE } from './ngoOsPricingData';

const CSS = `
.ngoos { --gold:#b3924f; --gold-soft:#d8c48d; --dark:#111111; --green:#1e7a45;
  --tint:#eaf6ee; --paper:#f6f3ec; --card:#ffffff; --rule:#e6e0d4; --ink-2:#5a5348;
  background:var(--paper); color:var(--dark); font-family:'Inter',system-ui,sans-serif; }
.ngoos section { background:var(--paper); }
.ngoos section.alt { background:#efeade; }
.ngoos .wrap { max-width:1200px; margin:0 auto; padding:0 20px; }
.ngoos h1,.ngoos h2 { font-family:'Libre Baskerville',Georgia,serif; letter-spacing:-.01em; }
.ngoos h1 { font-size:clamp(2rem,4.6vw,3.2rem); line-height:1.12; margin:0 0 20px; }
.ngoos h2 { font-size:clamp(1.5rem,3vw,2.1rem); margin:0 0 10px; }
.ngoos section { padding:64px 0; border-top:1px solid var(--rule); }
.ngoos section:first-child { border-top:0; }

.ngoos .hero { background:var(--dark); color:#fff;
  padding:var(--hero-pt) 0 var(--hero-pb); }
@media (max-width:768px){ .ngoos .hero {
  padding:var(--hero-pt-mobile) 0 var(--hero-pb-mobile); } }
.ngoos .hero h1 { color:#fff; }
.ngoos .hero p { font-size:1.12rem; line-height:1.7; color:#d6d6d6; max-width:62ch; }
.ngoos .hero strong { color:var(--gold); }
.ngoos .chips { display:flex; flex-wrap:wrap; gap:10px; margin:26px 0 30px; }
.ngoos .chip { border:1px solid rgba(179,146,79,.5); color:var(--gold);
  padding:7px 15px; border-radius:999px; font-size:.86rem; }
.ngoos .ctas { display:flex; flex-wrap:wrap; gap:12px; }
.ngoos .btn { display:inline-block; padding:13px 26px; border-radius:8px; font-weight:700;
  font-size:.94rem; text-decoration:none; cursor:pointer; border:1px solid transparent; }
.ngoos .btn-primary { background:var(--gold); color:#111; }
.ngoos .btn-ghost { border-color:rgba(255,255,255,.35); color:#fff; }

.ngoos .plans { display:grid; grid-template-columns:repeat(auto-fit,minmax(270px,1fr)); gap:20px; }
.ngoos .plan { border:1px solid var(--rule); border-radius:14px; padding:26px;
  position:relative; background:var(--card); }
.ngoos .plan.rec { border-color:var(--green); background:var(--tint); }
.ngoos .badge { position:absolute; top:-11px; left:26px; background:var(--green); color:#fff;
  font-size:.66rem; font-weight:700; letter-spacing:.09em; padding:4px 11px; border-radius:999px; }
.ngoos .plan h3 { font-size:.8rem; letter-spacing:.12em; color:#666; margin:0 0 12px; }
.ngoos .price { font-size:2rem; font-weight:800; }
.ngoos .gst { font-size:.82rem; color:#666; font-weight:500; }
.ngoos .plan ul { list-style:none; padding:0; margin:16px 0 0; font-size:.9rem; }
.ngoos .plan li { padding:7px 0; border-top:1px solid rgba(0,0,0,.07); color:#444; }

.ngoos .tablewrap { overflow-x:auto; border:1px solid #e4e4e4; border-radius:12px; }
.ngoos table { width:100%; border-collapse:collapse; font-size:.9rem; min-width:760px; }
.ngoos th,.ngoos td { padding:13px 16px; text-align:left; border-bottom:1px solid var(--rule); vertical-align:top; }
.ngoos th { background:#fafafa; font-size:.72rem; letter-spacing:.09em; text-transform:uppercase; color:#666; }
.ngoos th.rec,.ngoos td.rec { background:var(--tint); }
.ngoos td.feat { font-weight:600; min-width:220px; }
.ngoos tr:last-child td { border-bottom:0; }

.ngoos-tip-wrap { position:relative; display:inline-flex; margin-left:6px; vertical-align:middle; }
.ngoos-tip-btn { width:14px; height:14px; border-radius:50%; border:1px solid var(--gold);
  background:transparent; color:var(--gold); opacity:.6; font-size:9px; line-height:1;
  font-style:italic; font-weight:700; cursor:pointer; display:flex; align-items:center;
  justify-content:center; padding:0; }
.ngoos-tip-btn:hover,.ngoos-tip-btn:focus-visible { opacity:1; outline-offset:2px; }
.ngoos-tip { position:absolute; left:50%; transform:translateX(-50%); width:max-content;
  max-width:320px; background:var(--dark); color:#fff; font-size:.8rem; font-weight:400;
  line-height:1.5; padding:10px 13px; border-radius:8px; z-index:40; white-space:normal;
  box-shadow:0 8px 26px rgba(0,0,0,.28); }
.ngoos-tip.above { bottom:calc(100% + 8px); }
.ngoos-tip.below { top:calc(100% + 8px); }

.ngoos .note { background:#fafafa; border-left:3px solid var(--gold); padding:16px 20px;
  border-radius:0 8px 8px 0; font-size:.92rem; line-height:1.65; color:#444; margin-top:18px; }
.ngoos .faq { border-bottom:1px solid #eee; }
.ngoos .faq button { width:100%; text-align:left; background:none; border:0; padding:17px 0;
  font-size:1rem; font-weight:600; cursor:pointer; display:flex; justify-content:space-between; gap:16px; }
.ngoos .faq p { margin:0 0 17px; color:#555; line-height:1.7; font-size:.93rem; max-width:70ch; }
.ngoos .final { background:var(--dark); color:#fff; text-align:center; }
.ngoos .final h2 { color:#fff; }
@media (prefers-reduced-motion:reduce){ .ngoos *{transition:none!important} }

/* ---- value blocks ---- */
.ngoos .det { display:block; font-size:.79rem; color:#8a8172; font-weight:400; margin-top:3px; }
.ngoos .reframe { border:1px solid var(--gold-soft); background:#fbf7ec; border-radius:12px;
  padding:15px 18px; margin-top:14px; }
.ngoos .reframe h4 { margin:0 0 5px; font-size:.78rem; letter-spacing:.07em; font-weight:700;
  text-transform:uppercase; color:var(--gold); }
.ngoos .reframe p { margin:0; font-size:.92rem; line-height:1.6; color:#3c362c; }
.ngoos .yeartwo { display:grid; grid-template-columns:repeat(auto-fit,minmax(280px,1fr));
  gap:18px; margin-top:24px; }
.ngoos .step { background:var(--card); border:1px solid var(--rule); border-radius:14px; padding:24px; }
.ngoos .step .yr { font-size:.72rem; letter-spacing:.12em; text-transform:uppercase;
  font-weight:700; color:var(--gold); }
.ngoos .step .pl { font-family:'Libre Baskerville',Georgia,serif; font-size:1.2rem; margin:8px 0 10px; }
.ngoos .step p { margin:0; font-size:.94rem; line-height:1.65; color:var(--ink-2); }
.ngoos .keepbar { margin-top:22px; background:var(--dark); color:#fff; border-radius:14px; padding:24px 26px; }
.ngoos .keepbar a { color:var(--gold-soft); }
.ngoos .bench { background:var(--card); border:1px solid var(--rule); border-radius:14px;
  padding:24px; margin-top:18px; }
.ngoos .bench .need { font-family:'Libre Baskerville',Georgia,serif; font-size:1.16rem; margin:0 0 6px; }
.ngoos .bench .we { display:inline-block; background:var(--tint); color:var(--green); font-weight:700;
  font-size:.85rem; padding:5px 12px; border-radius:999px; margin:0 0 12px; }
.ngoos .vend { display:flex; flex-wrap:wrap; gap:6px 18px; justify-content:space-between;
  align-items:baseline; padding:11px 0; border-top:1px solid var(--rule); font-size:.92rem; }
.ngoos .vend a { color:var(--dark); text-decoration:underline; text-underline-offset:3px;
  text-decoration-color:var(--gold-soft); }
.ngoos .vend .amt { font-weight:700; white-space:nowrap; }
.ngoos .srcline { font-size:.79rem; color:#8a8172; margin-top:10px; line-height:1.6; max-width:80ch; }

/* ---- the problems, answered ---- */
.ngoos .blaze { background:var(--dark); color:#fff; }
.ngoos .blaze h2 { color:#fff; max-width:20ch; }
.ngoos .blaze .kicker { font-size:.74rem; letter-spacing:.16em; text-transform:uppercase;
  color:var(--gold); font-weight:700; margin:0 0 14px; }
.ngoos .blaze .lede { color:#c9c3b6; max-width:62ch; line-height:1.75; font-size:1.03rem; margin:0 0 34px; }
.ngoos .pain { border-top:1px solid rgba(255,255,255,.14); }
.ngoos .pain:last-child { border-bottom:1px solid rgba(255,255,255,.14); }
.ngoos .pain button { width:100%; background:none; border:0; cursor:pointer; text-align:left;
  padding:22px 0; display:flex; gap:18px; align-items:flex-start; color:#fff;
  font-family:'Libre Baskerville',Georgia,serif; font-size:clamp(1.02rem,2.1vw,1.32rem);
  line-height:1.4; }
.ngoos .pain .qtext { flex:1; transition:color .35s ease, opacity .35s ease; }
.ngoos .pain.open .qtext { color:#8f8878; text-decoration:line-through;
  text-decoration-color:var(--gold); text-decoration-thickness:1px; }
.ngoos .pain .mark { flex:none; width:26px; height:26px; margin-top:4px; border-radius:50%;
  border:1px solid var(--gold); color:var(--gold); display:grid; place-items:center;
  font-size:1.05rem; line-height:1; font-family:'Inter',sans-serif;
  transition:transform .4s cubic-bezier(.4,0,.2,1), background .35s ease, color .35s ease; }
.ngoos .pain.open .mark { transform:rotate(135deg); background:var(--gold); color:var(--dark); }
.ngoos .painbody { display:grid; grid-template-rows:0fr;
  transition:grid-template-rows .45s cubic-bezier(.4,0,.2,1); }
.ngoos .pain.open .painbody { grid-template-rows:1fr; }
.ngoos .painbody > .inner { overflow:hidden; min-height:0; }
.ngoos .painbody .move { opacity:0; transform:translateY(-8px);
  transition:opacity .34s ease .06s, transform .34s cubic-bezier(.4,0,.2,1) .06s; }
.ngoos .pain.open .painbody .move { opacity:1; transform:none; }
.ngoos .painbody p { margin:0 0 22px 44px; color:#d6d0c4; line-height:1.75; max-width:70ch;
  font-size:1rem; }
.ngoos .painbody .tag { display:inline-block; margin:0 0 12px 44px; background:rgba(179,146,79,.16);
  border:1px solid rgba(179,146,79,.5); color:var(--gold); font-size:.72rem; font-weight:700;
  letter-spacing:.11em; text-transform:uppercase; padding:5px 12px; border-radius:999px;
  font-family:'Inter',sans-serif; }
@media (max-width:600px){
  .ngoos .painbody p, .ngoos .painbody .tag { margin-left:0; }
}
@media (prefers-reduced-motion:reduce){
  .ngoos .painbody, .ngoos .painbody .move, .ngoos .pain .mark, .ngoos .pain .qtext {
    transition:none; }

}
`;

function Reframe({ k }: { k: keyof typeof REFRAMES }) {
  const r = REFRAMES[k];
  return <div className="reframe"><h4>{r.title}</h4><p>{r.body}</p></div>;
}

export default function NgoOsPricing() {
  const [openFaq, setOpenFaq] = useState<number | null>(0);
  const [openPain, setOpenPain] = useState<number | null>(0);


  return (
    <div className="ngoos">
      <SEO
        title="NGO OS Pricing | Donation Platform Plans from ₹25,000 — Govindani Infotech"
        description="Transparent pricing for Govindani NGO OS: donations, 80G receipts, donors, members, cases, campaigns, compliance, website and mobile app in one system. 0% commission on every rupee you raise, forever."
        canonical="https://govindaniit.com/pricing/ngo-os"
        keywords="NGO OS pricing, NGO donation platform India, 80G receipt software, NGO CRM pricing, 10BD 10BE filing software"
      />
      <style>{CSS}</style>

      <header className="hero">
        <div className="wrap">
          <h1>The operating system for Indian non-profits.</h1>
          <p>
            Donations, receipts, donors, members, cases, campaigns, compliance, website
            and mobile app — in one system. Your website included free.{' '}
            <strong>0% commission on every rupee you raise, forever.</strong>
          </p>
          <div className="chips">
            <span className="chip">80G receipt in under 4 seconds</span>
            <span className="chip">0% commission, permanently</span>
            <span className="chip">Your data exports free, any time</span>
          </div>
          <div className="ctas">
            <a className="btn btn-primary" href="/contact-us/">Book a 20-minute demo</a>
            <a className="btn btn-ghost" href="#included">See what's included</a>
          </div>
        </div>
      </header>

      <section className="blaze">
        <div className="wrap">
          <p className="kicker">{HEADLINE.kicker}</p>
          <h2>{HEADLINE.title}</h2>
          <p className="lede">{HEADLINE.body}</p>

          {PAINS.map((pn, i) => (
            <div className={`pain${openPain === i ? ' open' : ''}`} key={pn.q}>
              <button
                type="button"
                aria-expanded={openPain === i}
                aria-controls={`pain-${i}`}
                onClick={() => setOpenPain(openPain === i ? null : i)}
              >
                <span className="mark" aria-hidden="true">+</span>
                <span className="qtext">{pn.q}</span>
              </button>
              <div className="painbody" id={`pain-${i}`} role="region">
                <div className="inner">
                  <div className="move">
                    <span className="tag">{pn.tag}</span>
                    <p>{pn.a}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section>
        <div className="wrap">
          <h2>Plans</h2>
          <div className="plans">
            {PLANS.map(p => (
              <div key={p.name} className={`plan${p.rec ? ' rec' : ''}`}>
                {p.rec && <span className="badge">RECOMMENDED</span>}
                <h3>{p.name}</h3>
                <div className="price">{p.annual} <span className="gst">+ 18% GST</span></div>
                <ul>
                  <li>Monthly {p.monthly} + 18% GST</li>
                  <li>3 months (−8%) {p.q} + 18% GST</li>
                  <li>6 months (−10%) {p.h} + 18% GST</li>
                  <li>Website included: {p.site}</li>
                  <li>Best for: {p.best}</li>
                </ul>
                {p.rec && <Reframe k="advanced" />}
              </div>
            ))}
          </div>
          <p className="note">
            <strong>Custom plan:</strong> From ₹15,000/month + 18% GST — for organisations
            at national scale. Terms negotiated.
          </p>
          <p className="note">
            Annual billing carries a 16.7% saving — effectively two months free. Your plan
            price is locked for your full term. Any revision applies only with 30 days'
            written notice and is never retrospective.
          </p>
        </div>
      </section>

      <section className="alt">
        <div className="wrap">
          <h2>{YEAR_TWO.title}</h2>
          <p style={{ color: 'var(--ink-2)', maxWidth: '72ch', lineHeight: 1.7, fontSize: '1.02rem' }}>
            {YEAR_TWO.lead}
          </p>
          <div className="yeartwo">
            {YEAR_TWO.steps.map((st) => (
              <div className="step" key={st.year}>
                <div className="yr">{st.year}</div>
                <div className="pl">{st.plan}</div>
                <p>{st.body}</p>
              </div>
            ))}
          </div>
          <div className="keepbar">
            <p style={{ margin: 0, fontSize: '1.02rem', lineHeight: 1.7 }}>
              {YEAR_TWO.proof} <a href={YEAR_TWO.proofHref}>See our website price list</a>.
            </p>
          </div>
          <p className="note" style={{ marginTop: 18 }}>
            <strong>To be exact about what changes.</strong> {YEAR_TWO.caution}
          </p>
        </div>
      </section>

      <section id="included">
        <div className="wrap">
          <h2>Everything compared</h2>
          <div className="tablewrap">
            <table>
              <thead>
                <tr>
                  <th>Feature</th><th>Starter</th><th>Growth</th><th className="rec">Advanced</th>
                </tr>
              </thead>
              <tbody>
                {COMPARISON.map(r => (
                  <tr key={r.feature}>
                    <td className="feat">{r.feature}<InfoTip text={r.tip} /></td>
                    <td>{r.starter}</td>
                    <td>{r.growth}</td>
                    <td className="rec"><strong>{r.advanced}</strong></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <section>
        <div className="wrap">
          <h2>Your organisation, on your donor's phone.</h2>
          <Reframe k="app" />
          <p className="note">
            This is a <strong>converted application</strong>, not a separately designed
            native product. Once your website is built, its mobile view is moulded into a
            native application shell for Android and iOS. The screens, images and content
            inside the app are your website's own mobile screens — whatever a visitor sees
            on your website on a phone browser is exactly what they will see inside the
            application. What the application adds on top is real: an installable icon,
            working push notifications, in-app toggle controls, and donations completed
            inside the app.
          </p>
          <div className="tablewrap" style={{ marginTop: 22 }}>
            <table>
              <thead><tr><th>Option</th><th>What it covers</th><th>Charge</th></tr></thead>
              <tbody>
                <tr><td className="feat">Android application</td><td>Your website converted into an Android app with icon, push notifications and in-app donations, handed to you ready to publish.</td><td><strong>₹30,000</strong> + 18% GST</td></tr>
                <tr><td className="feat">iOS application</td><td>The same, built for Apple devices and handed to you ready to publish.</td><td><strong>₹30,000</strong> + 18% GST</td></tr>
                <tr><td className="feat">Complete bundle ⭐</td><td>Both applications built <strong>and pushed live onto both stores by our team</strong> — listing, submission, compliance declarations, data-safety forms and review handling managed end to end.</td><td><strong>₹1,00,000</strong> + 18% GST</td></tr>
              </tbody>
            </table>
          </div>
          <p className="note">
            <strong>Why the accounts must be in your name:</strong> a store account holds
            your organisation's legal identity, tax declarations and payout details. It must
            belong to you, permanently, so your application can never be held by anyone else.
            We will not take ownership of it, and no vendor ever should.
          </p>
          <p className="note">
            <strong>Review timeline:</strong> Google and Apple typically take 45 to 60 days
            to approve an application of this type. This period is controlled entirely by
            Google and Apple and sits outside our delivery timeline.
          </p>
        </div>
      </section>

      <section>
        <div className="wrap">
          <h2>Add-ons</h2>
          <p style={{ color: '#666', marginBottom: 20 }}>
            All optional. Added only when you need them, and shown on your invoice as a
            clear line item.
          </p>
          <div className="tablewrap">
            <table>
              <thead><tr><th>Add-on</th><th>Charge</th></tr></thead>
              <tbody>
                {ADDONS.map(a => (
                  <tr key={a.name}>
                    <td className="feat">{a.name}<InfoTip text={a.tip} /></td>
                    <td>{a.charge}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <Reframe k="server" />
          <Reframe k="message" />
        </section>

      <section>
        <div className="wrap">
          <h2>What you would otherwise be paying.</h2>
          <p style={{ color: '#555', maxWidth: '70ch', lineHeight: 1.7 }}>
            Most organisations do not buy one system. They buy six — a website from one
            vendor, a WhatsApp tool from another, an email platform from a third, a donation
            page from a fourth, spreadsheets for donors, and a chartered accountant's time to
            stitch 10BD together every May. Here is the honest arithmetic.
          </p>
          <div className="tablewrap" style={{ marginTop: 22 }}>
            <table>
              <thead><tr><th>What you need</th><th>Bought separately</th><th className="rec">With NGO OS Advanced</th></tr></thead>
              <tbody>
                <tr><td className="feat">A custom-coded website</td><td>₹89,999 one-time<span className="det">Our own Enterprise build, bought on its own</span></td><td className="rec"><strong>Included</strong></td></tr>
                <tr><td className="feat">Server, database &amp; load balancer</td><td>≈ ₹81,600 / year<span className="det">AWS Lightsail list price, $72/month</span></td><td className="rec"><strong>Included</strong></td></tr>
                <tr><td className="feat">A WhatsApp business platform</td><td>₹36,468 – ₹1,12,150 / year<span className="det">Interakt Advanced at the low end, Wati Growth at the high end</span></td><td className="rec"><strong>₹0 platform fee</strong> — per-message cost only</td></tr>
                <tr><td className="feat">Unlimited transactional email</td><td>Metered by every provider<span className="det">Amazon SES bills $0.10 per 1,000, plus a fixed fee on higher tiers</span></td><td className="rec"><strong>Unlimited — free</strong></td></tr>
                <tr><td className="feat">Commission on what you raise</td><td>Typically 2–5% of every rupee</td><td className="rec"><strong>0%, permanently</strong></td></tr>
                <tr><td className="feat"><strong>Those four line items alone</strong></td><td><strong>₹2,08,067 in year one</strong><span className="det">Taking the cheapest verified option in every row</span></td><td className="rec"><strong>₹80,000 + 18% GST</strong></td></tr>
              </tbody>
            </table>
          </div>
          <p className="srcline">
            Every figure above was read off the vendor&rsquo;s own public pricing page on {VERIFIED_ON},
            and each one is linked in full below. USD converted at ₹94.4 = $1. We have deliberately taken
            the cheapest verified option in each row, and left out donor CRM, membership management and
            your chartered accountant&rsquo;s time for 10BD — because we could not source prices for those
            we were willing to publish.
          </p>

          <h2 style={{ marginTop: 44 }}>Check every number yourself.</h2>
          <p style={{ color: 'var(--ink-2)', maxWidth: '72ch', lineHeight: 1.7 }}>
            A pricing page that asks to be trusted is worth very little. Every claim we make about what
            the rest of the market charges is below, with the vendor&rsquo;s own link beside it. Open them.
            If a figure has moved since {VERIFIED_ON}, tell us and we will correct this page.
          </p>

          {BENCHMARKS.map((b) => (
            <div className="bench" key={b.need}>
              <p className="need">{b.need}</p>
              <span className="we">{b.weCharge}</span>
              <p style={{ margin: '0 0 6px', fontSize: '.94rem', lineHeight: 1.65, color: 'var(--ink-2)' }}>{b.weNote}</p>
              {b.market.map((mk) => (
                <div className="vend" key={mk.vendor + mk.cost}>
                  <a href={mk.url} target="_blank" rel="noopener noreferrer nofollow">{mk.vendor}<span className="det">{mk.detail}</span></a>
                  <span className="amt">{mk.cost}</span>
                </div>
              ))}
              {b.total && (
                <div className="vend"><strong>Running that stack yourself</strong><span className="amt">{b.total}</span></div>
              )}
              <div className="reframe"><h4>What that actually means</h4><p>{b.reframe}</p></div>
            </div>
          ))}

          <h2 style={{ marginTop: 44 }}>The commission trap</h2>
          <div className="tablewrap">
            <table>
              <thead><tr><th>Your annual collection</th><th>A platform charging 3%</th><th className="rec">Govindani NGO OS</th><th>You keep</th></tr></thead>
              <tbody>
                <tr><td className="feat">₹20,00,000</td><td>₹60,000 taken</td><td className="rec"><strong>₹0 taken</strong></td><td>₹60,000</td></tr>
                <tr><td className="feat">₹50,00,000</td><td>₹1,50,000 taken</td><td className="rec"><strong>₹0 taken</strong></td><td>₹1,50,000</td></tr>
                <tr><td className="feat">₹1,00,00,000</td><td>₹3,00,000 taken</td><td className="rec"><strong>₹0 taken</strong></td><td>₹3,00,000</td></tr>
              </tbody>
            </table>
          </div>
          <p className="note">
            <strong>Read that line again.</strong> An organisation raising ₹1 crore a year
            on a 3% platform hands over ₹3,00,000 — nearly four times our entire Advanced
            annual fee — for the privilege of collecting its own donations. We take{' '}
            <strong>0%, permanently.</strong>
          </p>
          <Reframe k="commission" />
        </div>
      </section>

      <section>
        <div className="wrap">
          <h2>What we commit to</h2>
          <div className="tablewrap">
            <table>
              <thead><tr><th>Commitment</th><th>Standard</th></tr></thead>
              <tbody>
                {TRUST.map(([k, v]) => (
                  <tr key={k}><td className="feat">{k}</td><td>{v}</td></tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <section>
        <div className="wrap">
          <h2>How billing actually behaves. Stated before you sign, not after.</h2>
          <p className="note">
            <strong>Usage auto-settlement.</strong> Usage charges — receipt overage, WhatsApp
            messages, email top-ups — accrue as you consume them and settle automatically
            once they cross your plan threshold: <strong>₹500 on Starter · ₹1,500 on Growth ·
            ₹5,000 on Advanced</strong>. If a settlement fails and remains unpaid for 48 hours,
            marketing sends pause until it clears. <strong>Donations, receipt issuing, your
            donor portal and your data export never stop.</strong> Your fundraising is never
            held for a usage bill.
          </p>
          <p className="note">
            <strong>If your growth outgrows shared infrastructure.</strong> Your plan runs on
            shared infrastructure that comfortably carries the great majority of organisations.
            If your donation volume, traffic or data size grows beyond what it can serve
            properly, your organisation moves onto a <strong>dedicated server of its own</strong>{' '}
            at <strong>₹15,000 per month + 18% GST</strong>. We tell you this is approaching
            before it happens, with the usage figures in front of you — never as a surprise on
            an invoice, and never as the reason your donation page slowed down.
          </p>
          <div className="tablewrap" style={{ marginTop: 18 }}>
            <table>
              <thead><tr><th>If a renewal invoice goes unpaid</th><th>What happens</th></tr></thead>
              <tbody>
                <tr><td className="feat">Days 1–7</td><td>Full function. A reminder banner appears and reminders are sent. Nothing is restricted.</td></tr>
                <tr><td className="feat">Days 8–30</td><td>Your admin panel becomes read-only. <strong>Your public website stays live and donations continue to be accepted and receipted.</strong></td></tr>
                <tr><td className="feat">Day 30 onward</td><td>Your public website is replaced with an Under Maintenance page. Billing and export screens remain open, and donors can still download their own past receipts.</td></tr>
                <tr><td className="feat">On payment</td><td>Everything restores instantly and completely. <strong>Nothing is lost at any stage.</strong></td></tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <section>
        <div className="wrap" style={{ maxWidth: 860 }}>
          <h2>Questions</h2>
          {FAQ.map(([q, a], i) => (
            <div className="faq" key={q}>
              <button onClick={() => setOpenFaq(openFaq === i ? null : i)} aria-expanded={openFaq === i}>
                <span>{q}</span><span aria-hidden="true">{openFaq === i ? '−' : '+'}</span>
              </button>
              {openFaq === i && <p>{a}</p>}
            </div>
          ))}
        </div>
      </section>

      <section className="final">
        <div className="wrap">
          <h2>Every rupee acknowledged. Every donor remembered. Every filing ready.</h2>
          <p style={{ color: '#d6d6d6', maxWidth: '62ch', margin: '14px auto 26px', lineHeight: 1.7 }}>
            Book a twenty-minute demo and we will show you your own numbers inside the
            system — your donors, your receipts, your compliance position — before you
            commit to anything.
          </p>
          <div className="ctas" style={{ justifyContent: 'center' }}>
            <a className="btn btn-primary" href="/contact-us/">Book a demo</a>
            <a className="btn btn-ghost" href="https://wa.me/919201958271">
              Talk to us on WhatsApp — +91 92019 58271
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
